import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Button from '@mui/material/Button'
import {
  Box,
  MenuItem,
  Divider,
  IconButton,
  ThemeProvider,
  createTheme,
  Typography,
  Stack,
  ButtonGroup,
  ToggleButton,
} from '@mui/material'
import React, { useContext, useState } from 'react'
import CustomDropdown from '../../components/CustomDropdown'
import { useDispatch, useSelector } from 'react-redux'
import {
  resetConstructionState,
  setSelectedBuildingMode,
  setSelectedConstructionPage,
  setSelectedConstructionTab,
  setSelectedStoreyId,
  setHideShowOption,
  setIs2DViewActive,
} from '../../actions/construction'
import { RootState } from '../../store'
import { ConstructionPage, ConstructionTab } from '../../reducers/construction'
import { useNavigate } from 'react-router-dom'
import { clearState } from '../../actions/files'
import { resetCodeValidationState } from '../../actions/validation'
import { showItemList } from '../../actions/takeOff'
import { AIIcon, ArrowDownIcon } from '../../components/Svgs'
import { SelectionManager } from '../../visualization/selection/selectionManager'
import { AbilityContext } from '../../utils/AbilityUtil'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../models/AccessControl'
import { showAssignProjectDialog } from '../../actions/organization'
import { StructuralAnimationStatus } from '../../reducers/structural'
import {
  BuildingElementStatus,
  BuildingViewMode,
  HideShowOption,
} from '../../models/Construction'
import {
  endStructuralAnimation,
  resetStructuralState,
} from '../../actions/structural'
import { fetchEngineerOrganizationAsync } from '../../services/reviewService'
import { fetchPaymentStatusAsync } from '../../services/paymentService'

const theme = createTheme({
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&::placeholder': {
            color: '#04002E',
            fontSize: '12px',
            lineHeight: 'normal',
          },
          color: '#04002E',
          fontSize: '12px',
          lineHeight: 'normal',
          padding: '0 !important',
        },
      },
    },
  },
})

const percentages = [30, 50, 70, 100]

interface SvgIconProps {
  disabled?: boolean
  color?: string
}

const SvgIcon1: React.FC<SvgIconProps> = ({ disabled }) => (
  <svg
    width='27'
    height='27'
    viewBox='0 0 27 27'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask
      id='path-1-outside-1_377_14'
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='27'
      height='27'
      fill='black'
    >
      <rect fill='white' width='27' height='27' />
      <path d='M25.8199 7.79698L20.8968 4.48587C20.8968 4.48587 20.886 4.47779 20.8792 4.47375C20.7573 4.40101 20.6043 4.39697 20.4797 4.46297L16.1539 6.7503V1.40377C16.1539 1.26232 16.0794 1.13031 15.9561 1.05757C15.8342 0.984825 15.6812 0.980784 15.5566 1.04679L1.21534 8.63082C1.08262 8.70087 1 8.83827 1 8.9878V18.8713C1 19.0127 1.07449 19.1447 1.19638 19.2175C1.19638 19.2175 1.19774 19.2175 1.19909 19.2175L1.17336 19.2552L6.09643 22.6714L6.12216 22.6337C6.18582 22.6714 6.2576 22.6902 6.32802 22.6902C6.39303 22.6902 6.4594 22.6741 6.51899 22.6431L10.8448 20.3558V25.5959C10.8448 25.7373 10.9193 25.8693 11.0425 25.9421C11.1062 25.9811 11.1793 26 11.2511 26C11.3161 26 11.3825 25.9838 11.4421 25.9529L25.7847 18.3688C25.9174 18.2988 26 18.1614 26 18.0118V8.13106C26 7.99635 25.9309 7.87242 25.8199 7.79833V7.79698ZM21.0769 14.4892V10.9761L25.1874 8.80325V17.2534L21.0769 14.4892ZM21.0769 10.0614V5.58239L24.8068 8.0893L21.0769 10.0614ZM15.3426 7.18002L6.35782 11.9312L2.1837 9.0336L15.3426 2.07596V7.18002ZM1.81261 18.1977V9.76236L5.92307 12.6155V16.0249L1.81261 18.1977ZM5.92307 16.9409V21.5668L2.14037 18.9413L5.92307 16.9409ZM15.3426 8.09603V11.0448L6.73568 15.5965V12.6478L15.3426 8.09603ZM6.73568 21.6153V16.5112L15.9399 11.6442C16.0726 11.5742 16.1552 11.4368 16.1552 11.2873V7.66632L20.2657 5.49348V10.4911L11.0615 15.3581C10.9288 15.4282 10.8461 15.5656 10.8461 15.7151V19.4424L6.73568 21.6153ZM20.2643 11.4058V14.461L11.6574 19.0127V15.9576L20.2643 11.4071V11.4058ZM11.6574 19.9274L20.6462 15.1749L24.8068 17.9728L11.6574 24.925V19.9274Z' />
    </mask>
    <path
      d='M25.8199 7.79698L20.8968 4.48587C20.8968 4.48587 20.886 4.47779 20.8792 4.47375C20.7573 4.40101 20.6043 4.39697 20.4797 4.46297L16.1539 6.7503V1.40377C16.1539 1.26232 16.0794 1.13031 15.9561 1.05757C15.8342 0.984825 15.6812 0.980784 15.5566 1.04679L1.21534 8.63082C1.08262 8.70087 1 8.83827 1 8.9878V18.8713C1 19.0127 1.07449 19.1447 1.19638 19.2175C1.19638 19.2175 1.19774 19.2175 1.19909 19.2175L1.17336 19.2552L6.09643 22.6714L6.12216 22.6337C6.18582 22.6714 6.2576 22.6902 6.32802 22.6902C6.39303 22.6902 6.4594 22.6741 6.51899 22.6431L10.8448 20.3558V25.5959C10.8448 25.7373 10.9193 25.8693 11.0425 25.9421C11.1062 25.9811 11.1793 26 11.2511 26C11.3161 26 11.3825 25.9838 11.4421 25.9529L25.7847 18.3688C25.9174 18.2988 26 18.1614 26 18.0118V8.13106C26 7.99635 25.9309 7.87242 25.8199 7.79833V7.79698ZM21.0769 14.4892V10.9761L25.1874 8.80325V17.2534L21.0769 14.4892ZM21.0769 10.0614V5.58239L24.8068 8.0893L21.0769 10.0614ZM15.3426 7.18002L6.35782 11.9312L2.1837 9.0336L15.3426 2.07596V7.18002ZM1.81261 18.1977V9.76236L5.92307 12.6155V16.0249L1.81261 18.1977ZM5.92307 16.9409V21.5668L2.14037 18.9413L5.92307 16.9409ZM15.3426 8.09603V11.0448L6.73568 15.5965V12.6478L15.3426 8.09603ZM6.73568 21.6153V16.5112L15.9399 11.6442C16.0726 11.5742 16.1552 11.4368 16.1552 11.2873V7.66632L20.2657 5.49348V10.4911L11.0615 15.3581C10.9288 15.4282 10.8461 15.5656 10.8461 15.7151V19.4424L6.73568 21.6153ZM20.2643 11.4058V14.461L11.6574 19.0127V15.9576L20.2643 11.4071V11.4058ZM11.6574 19.9274L20.6462 15.1749L24.8068 17.9728L11.6574 24.925V19.9274Z'
      fill={disabled ? '#BBBCBC' : '#04002E'}
    />
    <path
      d='M25.8199 7.79698L20.8968 4.48587C20.8968 4.48587 20.886 4.47779 20.8792 4.47375C20.7573 4.40101 20.6043 4.39697 20.4797 4.46297L16.1539 6.7503V1.40377C16.1539 1.26232 16.0794 1.13031 15.9561 1.05757C15.8342 0.984825 15.6812 0.980784 15.5566 1.04679L1.21534 8.63082C1.08262 8.70087 1 8.83827 1 8.9878V18.8713C1 19.0127 1.07449 19.1447 1.19638 19.2175C1.19638 19.2175 1.19774 19.2175 1.19909 19.2175L1.17336 19.2552L6.09643 22.6714L6.12216 22.6337C6.18582 22.6714 6.2576 22.6902 6.32802 22.6902C6.39303 22.6902 6.4594 22.6741 6.51899 22.6431L10.8448 20.3558V25.5959C10.8448 25.7373 10.9193 25.8693 11.0425 25.9421C11.1062 25.9811 11.1793 26 11.2511 26C11.3161 26 11.3825 25.9838 11.4421 25.9529L25.7847 18.3688C25.9174 18.2988 26 18.1614 26 18.0118V8.13106C26 7.99635 25.9309 7.87242 25.8199 7.79833V7.79698ZM21.0769 14.4892V10.9761L25.1874 8.80325V17.2534L21.0769 14.4892ZM21.0769 10.0614V5.58239L24.8068 8.0893L21.0769 10.0614ZM15.3426 7.18002L6.35782 11.9312L2.1837 9.0336L15.3426 2.07596V7.18002ZM1.81261 18.1977V9.76236L5.92307 12.6155V16.0249L1.81261 18.1977ZM5.92307 16.9409V21.5668L2.14037 18.9413L5.92307 16.9409ZM15.3426 8.09603V11.0448L6.73568 15.5965V12.6478L15.3426 8.09603ZM6.73568 21.6153V16.5112L15.9399 11.6442C16.0726 11.5742 16.1552 11.4368 16.1552 11.2873V7.66632L20.2657 5.49348V10.4911L11.0615 15.3581C10.9288 15.4282 10.8461 15.5656 10.8461 15.7151V19.4424L6.73568 21.6153ZM20.2643 11.4058V14.461L11.6574 19.0127V15.9576L20.2643 11.4071V11.4058ZM11.6574 19.9274L20.6462 15.1749L24.8068 17.9728L11.6574 24.925V19.9274Z'
      stroke={disabled ? '#BBBCBC' : '#04002E'}
      strokeWidth='0.2'
      mask='url(#path-1-outside-1_377_14)'
    />
  </svg>
)

const SvgIcon2: React.FC<SvgIconProps> = ({ disabled }) => (
  <svg
    width='23'
    height='17'
    viewBox='0 0 23 17'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='0.5'
      y='0.5'
      width='9.66071'
      height='6.5'
      rx='0.5'
      stroke={disabled ? '#BBBCBC' : '#1705E5'}
    />
    <rect
      x='12.582'
      y='0.5'
      width='9.66071'
      height='6.5'
      rx='0.5'
      stroke={disabled ? '#BBBCBC' : '#1705E5'}
    />
    <rect
      x='0.5'
      y='10'
      width='9.66071'
      height='6.5'
      rx='0.5'
      stroke={disabled ? '#BBBCBC' : '#1705E5'}
    />
    <rect
      x='12.582'
      y='10'
      width='9.66071'
      height='6.5'
      rx='0.5'
      stroke={disabled ? '#BBBCBC' : '#1705E5'}
    />
  </svg>
)

const SvgHomeIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='10'
    height='10'
    viewBox='0 0 10 10'
    fill='none'
  >
    <path
      d='M3 7.25H7M4.69092 1.09385L1.22425 3.43824C1.08356 3.53338 1 3.6874 1 3.85158V8.2392C1 8.65938 1.35817 9 1.8 9H8.2C8.64183 9 9 8.65938 9 8.2392V3.85158C9 3.6874 8.91644 3.53338 8.77575 3.43824L5.30908 1.09385C5.12403 0.968715 4.87597 0.968715 4.69092 1.09385Z'
      stroke='#06004A'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

const EditorIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='11'
    height='11'
    viewBox='0 0 11 11'
    fill='none'
  >
    <path
      d='M3 1.49951C2.74841 1.4092 1.24317 0.97971 1.16093 1.00819C1.08943 1.03295 1.03324 1.08914 1.00848 1.16064C0.98 1.24288 1.02516 1.36867 1.11547 1.62026L3.93098 9.4635C4.04136 9.77102 4.09656 9.92477 4.17913 9.9697C4.25066 10.0086 4.33679 10.0098 4.40932 9.97272C4.49304 9.92998 4.55225 9.77772 4.67067 9.47321L5.95249 6.17712C5.97568 6.11747 5.98728 6.08765 6.0052 6.06253C6.02108 6.04027 6.04054 6.0208 6.0628 6.00492C6.08792 5.98701 6.11775 5.97541 6.1774 5.95221L9.47349 4.6704C9.778 4.55198 9.93026 4.49277 9.97301 4.40905C10.01 4.33652 10.0089 4.25039 9.96998 4.17886C9.92506 4.09629 9.92045 4.17886 8 3.5'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5.5 5C5.63158 5 5.72556 4.91184 5.74436 4.767C5.94486 3.06675 6.02632 3.01637 7.74937 2.74559C7.90601 2.7204 8 2.63854 8 2.5C8 2.36776 7.90601 2.2796 7.7807 2.25441C6.03258 1.91436 5.94486 1.92695 5.74436 0.232997C5.72556 0.0881612 5.63158 0 5.5 0C5.36842 0 5.27444 0.0881612 5.25564 0.2267C5.04261 1.95214 4.97995 2.01511 3.22556 2.25441C3.10025 2.267 3 2.36776 3 2.5C3 2.63224 3.09398 2.7204 3.2193 2.74559C4.98622 3.08564 5.03634 3.08564 5.25564 4.7796C5.27444 4.91184 5.36842 5 5.5 5Z'
      fill={color}
    />
  </svg>
)

const ValidationIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='11'
    height='12'
    viewBox='0 0 11 12'
    fill='none'
  >
    <path
      d='M5.17221 11.0866C5.36672 11.0866 5.50566 10.9563 5.53344 10.7422C5.82984 8.22877 5.95025 8.1543 8.49738 7.75401C8.72893 7.71678 8.86787 7.59576 8.86787 7.39096C8.86787 7.19548 8.72893 7.06515 8.54369 7.02792C5.95951 6.52523 5.82984 6.54385 5.53344 4.03974C5.50566 3.82564 5.36672 3.69531 5.17221 3.69531C4.97771 3.69531 4.83877 3.82564 4.81099 4.03043C4.49607 6.58109 4.40344 6.67418 1.81 7.02792C1.62476 7.04653 1.47656 7.19548 1.47656 7.39096C1.47656 7.58645 1.6155 7.71678 1.80074 7.75401C4.41271 8.2567 4.48681 8.2567 4.81099 10.7608C4.83877 10.9563 4.97771 11.0866 5.17221 11.0866Z'
      fill={color}
    />
    <path
      d='M2.21739 4.43478C2.3341 4.43478 2.41746 4.35659 2.43413 4.22812C2.61196 2.72007 2.68421 2.67539 4.21249 2.43522C4.35142 2.41288 4.43478 2.34027 4.43478 2.21739C4.43478 2.1001 4.35142 2.0219 4.24027 1.99956C2.68977 1.69795 2.61196 1.70912 2.43413 0.206659C2.41746 0.0781951 2.3341 0 2.21739 0C2.10069 0 2.01733 0.0781952 2.00065 0.201073C1.8117 1.73146 1.75613 1.78732 0.200065 1.99956C0.088918 2.01073 0 2.1001 0 2.21739C0 2.33468 0.0833606 2.41288 0.194508 2.43522C1.76169 2.73683 1.80615 2.73683 2.00065 4.23929C2.01733 4.35659 2.10069 4.43478 2.21739 4.43478Z'
      fill={color}
    />
    <path
      d='M8.86889 5.91355C8.94669 5.91355 9.00226 5.86142 9.01338 5.77578C9.13193 4.77041 9.1801 4.74063 10.199 4.58051C10.2916 4.56562 10.3471 4.51721 10.3471 4.43529C10.3471 4.3571 10.2916 4.30497 10.2175 4.29007C9.1838 4.089 9.13193 4.09645 9.01338 3.0948C9.00226 3.00916 8.94669 2.95703 8.86889 2.95703C8.79108 2.95703 8.73551 3.00916 8.72439 3.09108C8.59843 4.11134 8.56138 4.14858 7.524 4.29007C7.4499 4.29752 7.39062 4.3571 7.39062 4.43529C7.39062 4.51349 7.4462 4.56562 7.5203 4.58051C8.56508 4.78158 8.59472 4.78158 8.72439 5.78323C8.73551 5.86142 8.79108 5.91355 8.86889 5.91355Z'
      fill={color}
    />
  </svg>
)

const TakeoffIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='17'
    height='14'
    viewBox='0 0 17 14'
    fill='none'
  >
    <path
      d='M14.2174 4.43478C14.3341 4.43478 14.4175 4.35659 14.4341 4.22812C14.612 2.72007 14.6842 2.67539 16.2125 2.43522C16.3514 2.41288 16.4348 2.34027 16.4348 2.21739C16.4348 2.1001 16.3514 2.0219 16.2403 1.99956C14.6898 1.69795 14.612 1.70912 14.4341 0.206659C14.4175 0.0781951 14.3341 0 14.2174 0C14.1007 0 14.0173 0.0781952 14.0007 0.201073C13.8117 1.73146 13.7561 1.78732 12.2001 1.99956C12.0889 2.01073 12 2.1001 12 2.21739C12 2.33468 12.0834 2.41288 12.1945 2.43522C13.7617 2.73683 13.8061 2.73683 14.0007 4.23929C14.0173 4.35659 14.1007 4.43478 14.2174 4.43478Z'
      fill={color}
    />
    <path
      d='M1.47826 13.9565C1.55606 13.9565 1.61164 13.9044 1.62275 13.8187C1.74131 12.8134 1.78947 12.7836 2.80833 12.6235C2.90095 12.6086 2.95652 12.5602 2.95652 12.4783C2.95652 12.4001 2.90095 12.3479 2.82685 12.333C1.79318 12.132 1.74131 12.1394 1.62275 11.1378C1.61164 11.0521 1.55606 11 1.47826 11C1.40046 11 1.34488 11.0521 1.33377 11.134C1.2078 12.1543 1.17075 12.1915 0.133377 12.333C0.0592786 12.3405 0 12.4001 0 12.4783C0 12.5565 0.0555737 12.6086 0.129672 12.6235C1.17446 12.8246 1.2041 12.8246 1.33377 13.8262C1.34488 13.9044 1.40046 13.9565 1.47826 13.9565Z'
      fill={color}
    />
    <rect
      x='2.95703'
      y='2'
      width='8.47826'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='1'
      y='2'
      width='1.30435'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='2.95703'
      y='3.71973'
      width='8.47826'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='1'
      y='3.71973'
      width='1.30435'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='2.95703'
      y='5.44043'
      width='8.47826'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='12.0879'
      y='5.44043'
      width='3.91304'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='1'
      y='5.44043'
      width='1.30435'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='2.95703'
      y='7.26758'
      width='8.47826'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='12.0879'
      y='7.26758'
      width='3.91304'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='1'
      y='7.26758'
      width='1.30435'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='2.95703'
      y='8.9873'
      width='8.47826'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='12.0879'
      y='8.9873'
      width='3.91304'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='1'
      y='8.9873'
      width='1.30435'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='2.95703'
      y='10.707'
      width='8.47826'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
    <rect
      x='12.0879'
      y='10.707'
      width='3.91304'
      height='1.07506'
      rx='0.537531'
      fill={color}
    />
  </svg>
)

const PermitIcon: React.FC<SvgIconProps> = ({ color }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='13'
    height='14'
    viewBox='0 0 13 14'
    fill='none'
  >
    <path
      d='M7 11C7.15789 11 7.27068 10.8942 7.29323 10.7204C7.53383 8.6801 7.63158 8.61965 9.69925 8.29471C9.88722 8.26448 10 8.16625 10 8C10 7.84131 9.88722 7.73552 9.73684 7.70529C7.6391 7.29723 7.53383 7.31234 7.29323 5.2796C7.27068 5.10579 7.15789 5 7 5C6.84211 5 6.72932 5.10579 6.70677 5.27204C6.45113 7.34257 6.37594 7.41814 4.27068 7.70529C4.1203 7.7204 4 7.84131 4 8C4 8.15869 4.11278 8.26448 4.26316 8.29471C6.38346 8.70277 6.44361 8.70277 6.70677 10.7355C6.72932 10.8942 6.84211 11 7 11Z'
      fill={color}
    />
    <path
      d='M5 6C5.10526 6 5.18045 5.92947 5.19549 5.8136C5.35589 4.4534 5.42105 4.4131 6.7995 4.19647C6.92481 4.17632 7 4.11083 7 4C7 3.89421 6.92481 3.82368 6.82456 3.80353C5.42607 3.53149 5.35589 3.54156 5.19549 2.1864C5.18045 2.07053 5.10526 2 5 2C4.89474 2 4.81955 2.07053 4.80451 2.18136C4.63409 3.56171 4.58396 3.61209 3.18045 3.80353C3.0802 3.8136 3 3.89421 3 4C3 4.10579 3.07519 4.17632 3.17544 4.19647C4.58897 4.46851 4.62907 4.46851 4.80451 5.82368C4.81955 5.92947 4.89474 6 5 6Z'
      fill={color}
    />
    <path
      d='M2.60052 0H11.2672C11.7269 0 12.1678 0.182619 12.4928 0.507682C12.8179 0.832745 13.0005 1.27362 13.0005 1.73333V12.1333C13.0005 12.593 12.8179 13.0339 12.4928 13.359C12.1678 13.684 11.7269 13.8667 11.2672 13.8667H2.60052C2.14081 13.8667 1.69993 13.684 1.37487 13.359C1.04981 13.0339 0.867188 12.593 0.867188 12.1333V11.2667H1.73385V12.1333C1.73385 12.3632 1.82516 12.5836 1.98769 12.7462C2.15023 12.9087 2.37067 13 2.60052 13H11.2672C11.497 13 11.7175 12.9087 11.88 12.7462C12.0425 12.5836 12.1339 12.3632 12.1339 12.1333V1.73333C12.1339 1.50348 12.0425 1.28304 11.88 1.12051C11.7175 0.957976 11.497 0.866667 11.2672 0.866667H2.60052C2.37067 0.866667 2.15023 0.957976 1.98769 1.12051C1.82516 1.28304 1.73385 1.50348 1.73385 1.73333V2.6H0.867188V1.73333C0.867188 1.27362 1.04981 0.832745 1.37487 0.507682C1.69993 0.182619 2.14081 0 2.60052 0V0Z'
      fill={color}
    />
    <path
      d='M0.866667 4.33346V3.90013C0.866667 3.7852 0.912321 3.67498 0.993587 3.59372C1.07485 3.51245 1.18507 3.4668 1.3 3.4668C1.41493 3.4668 1.52515 3.51245 1.60641 3.59372C1.68768 3.67498 1.73333 3.7852 1.73333 3.90013V4.33346H2.16667C2.28159 4.33346 2.39181 4.37912 2.47308 4.46038C2.55435 4.54165 2.6 4.65187 2.6 4.7668C2.6 4.88172 2.55435 4.99194 2.47308 5.07321C2.39181 5.15448 2.28159 5.20013 2.16667 5.20013H0.433333C0.318406 5.20013 0.208186 5.15448 0.12692 5.07321C0.0456546 4.99194 0 4.88172 0 4.7668C0 4.65187 0.0456546 4.54165 0.12692 4.46038C0.208186 4.37912 0.318406 4.33346 0.433333 4.33346H0.866667ZM0.866667 6.93346V6.50013C0.866667 6.3852 0.912321 6.27498 0.993587 6.19372C1.07485 6.11245 1.18507 6.0668 1.3 6.0668C1.41493 6.0668 1.52515 6.11245 1.60641 6.19372C1.68768 6.27498 1.73333 6.3852 1.73333 6.50013V6.93346H2.16667C2.28159 6.93346 2.39181 6.97912 2.47308 7.06038C2.55435 7.14165 2.6 7.25187 2.6 7.3668C2.6 7.48172 2.55435 7.59194 2.47308 7.67321C2.39181 7.75448 2.28159 7.80013 2.16667 7.80013H0.433333C0.318406 7.80013 0.208186 7.75448 0.12692 7.67321C0.0456546 7.59194 0 7.48172 0 7.3668C0 7.25187 0.0456546 7.14165 0.12692 7.06038C0.208186 6.97912 0.318406 6.93346 0.433333 6.93346H0.866667ZM0.866667 9.53346V9.10013C0.866667 8.9852 0.912321 8.87498 0.993587 8.79372C1.07485 8.71245 1.18507 8.6668 1.3 8.6668C1.41493 8.6668 1.52515 8.71245 1.60641 8.79372C1.68768 8.87498 1.73333 8.9852 1.73333 9.10013V9.53346H2.16667C2.28159 9.53346 2.39181 9.57912 2.47308 9.66038C2.55435 9.74165 2.6 9.85187 2.6 9.9668C2.6 10.0817 2.55435 10.1919 2.47308 10.2732C2.39181 10.3545 2.28159 10.4001 2.16667 10.4001H0.433333C0.318406 10.4001 0.208186 10.3545 0.12692 10.2732C0.0456546 10.1919 0 10.0817 0 9.9668C0 9.85187 0.0456546 9.74165 0.12692 9.66038C0.208186 9.57912 0.318406 9.53346 0.433333 9.53346H0.866667Z'
      fill={color}
    />
  </svg>
)

type Tab = {
  name: ConstructionTab
  icon: React.FC<SvgIconProps>
  action: (isClosed: boolean) => void
  isDisabled: boolean
}

type Page = {
  name: ConstructionPage
  svg: JSX.Element
  disabled: boolean
  action: (isClosed: boolean) => void
}

function Header() {
  const isShowUploadModal = useSelector(
    (state: RootState) => state.construction.showUploadModal,
  )
  const permit = useSelector((state: RootState) => state.permit)
  const navigate = useNavigate()

  const [view, setView] = useState<'2D' | '3D'>('2D')
  const [percentage, setPercentage] = useState<number>(percentages[0])
  const dispatch = useDispatch<any>()

  const selectedConstructionTab = useSelector(
    (state: RootState) => state.construction.selectedConstructionTab,
  )
  const selectedConstructionPage = useSelector(
    (state: RootState) => state.construction.selectedConstructionPage,
  )

  const structuralAnimationStatus = useSelector(
    (state: RootState) => state.structural.structuralAnimationStatus,
  )
  const buildingHasStructuralElements = useSelector(
    (state: RootState) =>
      state.construction.convertData.building.has_structural,
  )

  const buildingElementsStatus = useSelector(
    (state: RootState) => state.construction.buildingElementStatus,
  )
  const buildingComplete = buildingElementsStatus.every(
    (element) => element.status === BuildingElementStatus.Complete,
  )

  const selectedBuildingMode = useSelector(
    (state: RootState) => state.construction.selectedBuildingMode,
  )

  const isDisabled = () => {
    return isShowUploadModal || !buildingComplete
  }

  const organization = useSelector((state: RootState) => state.organization)
  const ability = useContext(AbilityContext)

  const SvgArchitecturePage = () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='10'
      height='15'
      viewBox='0 0 10 15'
      fill='none'
    >
      <path
        d='M7.65279 4.16667C7.65279 3.08333 6.90877 2.16667 5.88132 1.81667V0H4.10984V1.81667C3.08238 2.16667 2.33836 3.08333 2.33836 4.16667C2.33836 5.55 3.52525 6.66667 4.99558 6.66667C6.4659 6.66667 7.65279 5.55 7.65279 4.16667ZM4.99558 5C4.50842 5 4.10984 4.625 4.10984 4.16667C4.10984 3.70833 4.50842 3.33333 4.99558 3.33333C5.48273 3.33333 5.88132 3.70833 5.88132 4.16667C5.88132 4.625 5.48273 5 4.99558 5Z'
        fill={
          selectedConstructionPage === ConstructionPage.Architecture
            ? '#F2F2F2'
            : '#919191'
        }
      />
      <path
        d='M7.44907 6.56667C7.01506 6.95834 6.47476 7.24167 5.88132 7.38334L8.33481 13.7167L9.76971 15L10 13.15L7.44907 6.56667Z'
        fill={
          selectedConstructionPage === ConstructionPage.Architecture
            ? '#F2F2F2'
            : '#919191'
        }
      />
      <path
        d='M0 13.15L0.221435 15L1.65633 13.7167L4.10983 7.38334C3.50752 7.24167 2.97608 6.95834 2.54207 6.56667L0 13.15Z'
        fill={
          selectedConstructionPage === ConstructionPage.Architecture
            ? '#F2F2F2'
            : '#919191'
        }
      />
    </svg>
  )

  const SvgEngineeringPage = () => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
    >
      <path
        d='M11.988 2.91669C11.9788 2.80986 11.7404 2.60472 11.6395 2.56813C11.5383 2.53131 11.4251 2.55637 11.349 2.63206L9.82259 4.15846L7.83996 2.17583L9.3969 0.624747C9.4731 0.548914 9.49795 0.436089 9.46125 0.335495C9.42417 0.234701 9.17972 0.0211681 9.07227 0.011914C8.12672 -0.0692465 7.20025 0.267076 6.53041 0.934493C5.61301 1.84852 5.37006 3.18325 5.80027 4.32095C5.75325 4.36042 5.70685 4.40224 5.66108 4.44733L0.464019 9.33287C0.462186 9.33465 0.460378 9.3366 0.458395 9.33835C-0.152798 9.94727 -0.152798 10.938 0.458395 11.547C1.06969 12.1559 2.05691 12.1485 2.66801 11.5396C2.67064 11.5371 2.67305 11.5347 2.67546 11.532L7.53669 6.31415C7.581 6.2698 7.62215 6.22341 7.66094 6.17579C8.80324 6.60515 10.1439 6.3637 11.0621 5.44907C11.7318 4.7816 12.0696 3.85855 11.988 2.91669Z'
        fill={
          selectedConstructionPage === ConstructionPage.Engineering
            ? '#F2F2F2'
            : '#919191'
        }
      />
    </svg>
  )

  const handleTabClick = (tab: Omit<Tab, 'isDisabled'>) => {
    if (selectedConstructionTab === tab.name) {
      return
    }

    const oldTab = tabs.find((tab) => tab.name === selectedConstructionTab)
    oldTab?.action(true)
    tab.action(false)

    dispatch(setSelectedConstructionTab(tab.name))
  }

  const handlePercentageClick = (percentage: number) => {
    setPercentage(percentage)
  }

  const handleEditorTabClick = (isClosed: boolean) => {
    const selectionManager = SelectionManager.getInstance()
    selectionManager.clearCodeValidationMetadata()
    selectionManager.deselect()
  }

  const handleValidationTabClick = (isClosed: boolean) => {
    if (isClosed) {
      dispatch(resetCodeValidationState())
      // dispatch(deselectCodeValidationRule())
    }
  }

  const handleTakeOffTabClick = (isClosed: boolean) => {
    if (isClosed) {
      dispatch(showItemList(false))
    }
  }

  const handlePermitTabClick = (isClosed: boolean) => {
    if (isClosed) {
      dispatch(
        setSelectedBuildingMode({ mode: BuildingViewMode.WholeBuilding }),
      )
      dispatch(setSelectedConstructionPage(ConstructionPage.Architecture))
      dispatch(endStructuralAnimation())
    }
  }

  const handleToggleView = (event: any, newValue: '2D' | '3D') => {
    setView(newValue === '2D' ? '3D' : '2D')
    dispatch(setIs2DViewActive(newValue === '2D'))
  }

  const tabs: Tab[] = [
    {
      name: ConstructionTab.Editor,
      icon: EditorIcon,
      action: (isClosed: boolean) => handleEditorTabClick(isClosed),
      isDisabled: false,
    },
    {
      name: ConstructionTab.Validation,
      icon: ValidationIcon,
      action: (isClosed: boolean) => handleValidationTabClick(isClosed),
      isDisabled: ability.cannot(
        AttributeActionNames.Read,
        AttributeResourceNames.Validation,
      ),
    },
    {
      name: ConstructionTab.TakeOff,
      icon: TakeoffIcon,
      action: (isClosed: boolean) => handleTakeOffTabClick(isClosed),
      isDisabled: ability.cannot(
        AttributeActionNames.Read,
        AttributeResourceNames.TakeOff,
      ),
    },
    {
      name: ConstructionTab.Permit,
      icon: PermitIcon,
      action: (isClosed: boolean) => handlePermitTabClick(isClosed),
      isDisabled:
        Boolean(!permit.file) ||
        !!!permit.file?.pages ||
        !!!permit.file.pages.length ||
        !!!permit.file.pages[0].image ||
        ability.cannot(
          AttributeActionNames.Read,
          AttributeResourceNames.Permit,
        ),
    },
  ]

  const handlePageClick = (page: Page) => {
    if (selectedConstructionPage === page.name) {
      return
    }

    const oldPage = pages.find((page) => page.name === selectedConstructionPage)
    oldPage?.action(true)
    page.action(false)

    dispatch(setSelectedConstructionPage(page.name))
  }

  const pages: Page[] = [
    {
      name: ConstructionPage.Architecture,
      svg: <SvgArchitecturePage />,
      disabled:
        (selectedConstructionPage === ConstructionPage.Engineering &&
          structuralAnimationStatus !== StructuralAnimationStatus.Completed) ||
        ability.cannot(
          AttributeActionNames.Read,
          AttributeResourceNames.Architecture,
        ),
      action: () => {},
    },
    {
      name: ConstructionPage.Engineering,
      svg: <SvgEngineeringPage />,
      disabled:
        !buildingHasStructuralElements ||
        ability.cannot(
          AttributeActionNames.Read,
          AttributeResourceNames.StructuralEngineering,
        ),
      action: (isClosed: boolean) => {
        dispatch(
          setSelectedBuildingMode({ mode: BuildingViewMode.StackableView }),
        )
        dispatch(setSelectedStoreyId(null))
        dispatch(
          setHideShowOption({
            option: HideShowOption.WallsTransparency,
            isEnabled: !isClosed,
          }),
        )
      },
    },
  ]

  return (
    <ThemeProvider theme={theme}>
      <AppBar
        position='static'
        sx={{
          zIndex: 1,
          height: '52px',
          borderBottom: '1px solid #D0D0D0',
          backgroundColor: '#fff',
          boxShadow: 'none',
          boxSizing: 'border-box',
        }}
      >
        <Toolbar
          variant='dense'
          sx={{
            pl: '12px !important',
            pr: '12px !important',
            height: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
              }}
            >
              <CustomDropdown
                disabled={isDisabled()}
                svg={<SvgIcon1 disabled={isDisabled()} />}
                color='#04002E'
                width={164}
              >
                <MenuItem
                  onClick={() => {
                    dispatch(clearState())
                    dispatch(resetConstructionState())
                    dispatch(resetStructuralState())
                    dispatch(resetCodeValidationState())
                    navigate('/projects')
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#06004A',

                        fontSize: '11px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        lineHeight: 'normal',
                      }}
                    >
                      Back to Home
                    </Typography>

                    <SvgHomeIcon />
                  </Box>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate('/extractor')
                    navigate(0)
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#06004A',

                        fontSize: '11px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        lineHeight: 'normal',
                      }}
                    >
                      Extractor
                    </Typography>
                  </Box>
                </MenuItem>
              </CustomDropdown>
            </Box>

            <Divider orientation='vertical' flexItem sx={{ my: '10px' }} />
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              height: '100%',
            }}
          >
            <Stack
              direction='row'
              sx={{
                ml: '20px',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <ButtonGroup
                size='small'
                color='primary'
                aria-label='Construction Tab'
                sx={{
                  borderRadius: '4px',
                  mr: '11px',
                  display: '-webkit-inline-box',
                  '& .MuiButtonGroup-grouped': {
                    borderRadius: '4px',
                    border: 'none',
                    minWidth: '53px',
                    position: 'relative',
                    zIndex: 2,
                  },
                  '& .MuiButtonGroup-grouped:hover': {
                    borderRadius: '4px',
                    border: 'none',
                  },
                }}
              >
                {tabs.map((tab, index) => (
                  <Button
                    key={index}
                    startIcon={
                      <tab.icon
                        color={
                          selectedConstructionTab === tab.name
                            ? '#fff'
                            : '#919191'
                        }
                      />
                    }
                    disabled={tab.isDisabled || isDisabled()}
                    onClick={() => handleTabClick(tab)}
                    sx={{
                      width: '89px',
                      textTransform: 'capitalize',
                      backgroundColor:
                        selectedConstructionTab === tab.name
                          ? '#1705E5'
                          : '#F2F2F2',
                      color:
                        selectedConstructionTab === tab.name
                          ? '#fff'
                          : '#919191',
                      fontSize: '12px',
                      lineHeight: 'normal',
                      border: 'none',
                      padding: '9px 12px',
                      zIndex: 3,
                      '&:hover': {
                        backgroundColor:
                          selectedConstructionTab === tab.name
                            ? '#1705E5'
                            : '#E5F0FF',
                      },
                      '&.Mui-disabled': {
                        border: 'none',
                      },
                      ...(selectedConstructionTab === tab.name ||
                      index === tabs.length - 1
                        ? {}
                        : {
                            '&::after': {
                              content: '""',
                              position: 'absolute',
                              right: 0,
                              height: '70%',
                              width: '2px',
                              backgroundColor: '#E0E0E0',
                            },
                          }),
                    }}
                  >
                    {tab.name}
                  </Button>
                ))}
              </ButtonGroup>
              {selectedConstructionTab === ConstructionTab.Editor && (
                <>
                  <Divider
                    orientation='vertical'
                    flexItem
                    sx={{ my: '10px' }}
                  />
                  <ButtonGroup
                    size='small'
                    color='primary'
                    aria-label='Construction Page'
                    sx={{
                      borderRadius: '4px',
                      ml: '11px',
                      display: '-webkit-inline-box',
                      '& .MuiButtonGroup-grouped': {
                        borderRadius: '4px',
                        border: 'none',
                        minWidth: '53px',
                      },
                      '& .MuiButtonGroup-grouped:hover': {
                        borderRadius: '4px',
                        background: '#E5F0FF',
                        border: 'none',
                      },
                    }}
                  >
                    {pages.map((page, index) => (
                      <IconButton
                        key={index}
                        disabled={page.disabled || isDisabled()}
                        onClick={() => handlePageClick(page)}
                        sx={{
                          width: '32px',
                          height: '32px',
                          backgroundColor:
                            selectedConstructionPage === page.name
                              ? '#1705E5'
                              : '#F2F2F2',
                          color:
                            selectedConstructionPage === page.name
                              ? '#fff'
                              : '#919191',
                          fontSize: '12px',
                          lineHeight: 'normal',
                          padding: '9px',
                          borderRadius: '4px',
                          '&:hover': {
                            backgroundColor:
                              selectedConstructionPage === page.name
                                ? '#1705E5'
                                : '#E5F0FF',
                          },
                          '&.Mui-disabled': {
                            backgroundColor:
                              selectedConstructionPage === page.name
                                ? '#1705E5'
                                : '#F2F2F2',
                          },
                        }}
                      >
                        {page.svg}
                      </IconButton>
                    ))}
                  </ButtonGroup>
                  {/* {selectedBuildingMode === BuildingViewMode.SingleStorey && ( */}
                    <>
                      <Divider
                        orientation='vertical'
                        flexItem
                        sx={{ px: '4px', my: '10px' }}
                      />
                      <ToggleButton
                        value={view}
                        onChange={handleToggleView}
                        disabled={isDisabled()}
                        sx={{
                          width: '32px',
                          height: '32px',
                          backgroundColor: '#F5F5F5',
                          color: 'black',
                          mx: '8px',
                        }}
                      >
                        {view}
                      </ToggleButton>
                    </>
                  {/* )} */}
                </>
              )}
            </Stack>

            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                gap={'5px'}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography
                  sx={{
                    color: '#04002E',
                    fontSize: '12px',
                    fontWeight: 500,
                    lineHeight: 'normal',
                  }}
                >
                  {organization.selectedFile?.name}
                </Typography>
                <IconButton
                  disableRipple
                  disabled={isDisabled()}
                  sx={{
                    p: '4px',
                    background: '#F2F2F2',
                    '&.Mui-disabled': {
                      background: '#F2F2F2',
                    },
                  }}
                >
                  <ArrowDownIcon color='#919191' />
                </IconButton>
                <Typography
                  sx={{
                    color: 'rgba(4, 0, 46, 0.30)',
                    fontSize: '8px',
                    fontWeight: 500,
                    lineHeight: 'normal',
                  }}
                >
                  in {organization.selectedProject?.name}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                width: '14%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <IconButton
                disableRipple
                disabled={isDisabled()}
                sx={{
                  borderRadius: '4px',
                  background: '#F2F2F2',
                  '&.Mui-disabled': {
                    background: '#F2F2F2',
                  },
                }}
              >
                <AIIcon color='white' />
              </IconButton>
              <CustomDropdown
                disabled={isDisabled()}
                imageSrcs={[
                  '/images/profile1.png',
                  '/images/profile2.png',
                  '/images/profile3.png',
                  '/images/profile4.png',
                  '/images/profile5.png',
                ]}
                color='#1705E5'
              >
                <MenuItem>
                  <Typography
                    sx={{
                      color: '#06004A',

                      fontSize: '11px',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      lineHeight: 'normal',
                    }}
                  >
                    Manage
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    dispatch(showAssignProjectDialog(true))
                    dispatch(fetchEngineerOrganizationAsync())
                    dispatch(
                      fetchPaymentStatusAsync({
                        fileId: organization.selectedFile?.id,
                      }),
                    )
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#06004A',

                        fontSize: '11px',
                        fontStyle: 'normal',
                        fontWeight: 500,
                        lineHeight: 'normal',
                      }}
                    >
                      Assign
                    </Typography>
                  </Box>
                </MenuItem>
              </CustomDropdown>
            </Box>

            <Divider orientation='vertical' flexItem sx={{ my: '10px' }} />
          </Box>
          <Box
            sx={{
              width: '19%',
              height: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                width: '24%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CustomDropdown
                disabled={isDisabled()}
                svg={<SvgIcon2 disabled={isDisabled()} />}
                color='#1705E5'
              >
                <MenuItem value={10}>Opt 1</MenuItem>
                <MenuItem value={20}>Opt 2</MenuItem>
                <MenuItem value={30}>Opt 3</MenuItem>
              </CustomDropdown>
            </Box>

            <Divider orientation='vertical' flexItem sx={{ my: '10px' }} />

            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  width: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              ></Box>
              <Box
                sx={{
                  width: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  disabled={isDisabled()}
                  disableRipple
                  sx={{
                    minWidth: '16px',
                    minHeight: '18px',
                    padding: 0,
                    lineHeight: 'normal',
                  }}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='18'
                    viewBox='0 0 16 18'
                    fill='none'
                  >
                    <path
                      d='M14.708 9L1.20801 16.7942L1.20801 1.20577L14.708 9Z'
                      stroke={isDisabled() ? '#BBBCBC' : '#1705E5'}
                    />
                  </svg>
                </Button>
                <Box
                  sx={{
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <CustomDropdown
                    disabled={isDisabled()}
                    title={percentage.toString() + '%'}
                    color='#1705E5'
                  >
                    {percentages
                      .filter((p) => p !== percentage)
                      .map((notSelected, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => handlePercentageClick(notSelected)}
                          value={notSelected}
                        >
                          {notSelected.toString() + '%'}
                        </MenuItem>
                      ))}
                  </CustomDropdown>
                </Box>
              </Box>
            </Box>

            <Divider orientation='vertical' flexItem sx={{ my: '10px' }} />

            <Box
              sx={{
                width: '12%',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={isDisabled()}
                disableRipple
                sx={{
                  minWidth: '16px',
                  minHeight: '18px',
                  padding: 0,
                  lineHeight: 'normal',
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='21'
                  height='21'
                  viewBox='0 0 21 21'
                  fill='none'
                >
                  <path
                    d='M18.1735 3.57141C18.1735 3.01913 17.7258 2.57141 17.1735 2.57141H1.56348C1.01119 2.57141 0.563477 3.01913 0.563477 3.57141V19.1814C0.563477 19.7337 1.01119 20.1814 1.56348 20.1814H12.5535L18.1735 14.5614V3.57141Z'
                    stroke={isDisabled() ? '#BBBCBC' : '#1705E5'}
                    strokeMiterlimit='10'
                  />
                  <path
                    d='M12.5518 20.1797L18.1718 14.5597H12.5518V20.1797Z'
                    stroke={isDisabled() ? '#BBBCBC' : '#1705E5'}
                    strokeLinejoin='round'
                  />
                  <circle
                    cx='16.5654'
                    cy='4.00244'
                    r='4'
                    fill='url(#paint0_linear_465_1363)'
                  />
                  <defs>
                    <linearGradient
                      id='paint0_linear_465_1363'
                      x1='14.5654'
                      y1='1.00244'
                      x2='20.5654'
                      y2='14.5024'
                      gradientUnits='userSpaceOnUse'
                    >
                      <stop stopColor='#FF3B47' />
                      <stop offset='1' stopColor='#FFBDD5' />
                    </linearGradient>
                  </defs>
                </svg>
              </Button>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  )
}

export default Header
